__turbopack_context__.v({
  "button": "TAL0hq_button",
  "content": "TAL0hq_content",
  "form": "TAL0hq_form",
  "headline": "TAL0hq_headline",
  "input": "TAL0hq_input",
  "layout": "TAL0hq_layout",
  "newsletterTile": "TAL0hq_newsletterTile",
  "optInTextError": "TAL0hq_optInTextError",
  "subHeading": "TAL0hq_subHeading",
  "successAlert": "TAL0hq_successAlert",
  "successBody": "TAL0hq_successBody",
  "successResetLink": "TAL0hq_successResetLink",
  "successful": "TAL0hq_successful",
});
